import { FormColorPicker } from "@circle-react-shared/uikit/Form/FormColorPicker";
import { FormInput } from "@circle-react-shared/uikit/Form/FormInput";
import { LinkInput } from "@circle-react-shared/uikit/Form/LinkInput";
import { Form } from "@circle-react-uikit/Form";
import type { Ref } from "react";

import { t } from "@/i18n-js/instance";
import { Item as FormItem } from "@/react/components/SettingsApp/CompassCompat/FormItem";
import { useCanMarkPurchaseFlow } from "@/react/helpers/purchaseFlowAnchor";

interface ButtonFormFieldsProps {
  inputRef: Ref<HTMLInputElement>;
  isWithinEmailEditor?: boolean;
}

const MayLeadToPurchaseCheckbox = () => (
  <Form.Checkbox
    name="may_lead_to_purchase"
    label={t("email_editor.cta.may_lead_to_purchase")}
    description={t("email_editor.cta.may_lead_to_purchase_description")}
  />
);

export const ButtonFormFields = ({
  inputRef,
  isWithinEmailEditor,
}: ButtonFormFieldsProps) => {
  const canMarkPurchaseFlow = useCanMarkPurchaseFlow();

  return (
    <div className="flex flex-col">
      <FormItem
        name="label"
        hidePlaceholder
        hideDescription
        hideBorder
        label={t("email_editor.cta.label")}
        required
        isFirstChild
      >
        <FormInput
          ref={inputRef}
          name="label"
          label={t("email_editor.cta.label")}
          placeholder={t("email_editor.cta.label")}
          autocomplete="off"
        />
      </FormItem>
      <FormItem
        name="url"
        hidePlaceholder
        hideDescription
        hideBorder
        label={t("email_editor.cta.url")}
        required
      >
        <LinkInput
          allowMailTo
          allowLiquidVariables={isWithinEmailEditor}
          label={t("email_editor.cta.url")}
          name="url"
          autocomplete="off"
        />
      </FormItem>
      <FormItem
        name="color"
        hidePlaceholder
        hideDescription
        hideBorder
        label={t("email_editor.cta.color")}
        required
      >
        <FormColorPicker name="color" />
      </FormItem>
      {!isWithinEmailEditor && canMarkPurchaseFlow && (
        <div className="pt-6">
          <MayLeadToPurchaseCheckbox />
        </div>
      )}
      {isWithinEmailEditor && (
        <FormItem
          name="text_color"
          hidePlaceholder
          hideDescription
          hideBorder
          label={t("email_editor.cta.text_color")}
          required
        >
          <FormColorPicker name="text_color" />
        </FormItem>
      )}
    </div>
  );
};
